import React, { useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Filter from '@strapi/icons/Filter';
import { Button } from '@strapi/design-system/Button';
import { Popover } from '@strapi/design-system/Popover';
import FilterBody from '../FilterBody';
import { toggleFiltersOpened, addFilter } from '../../redux/reducers/widenSearchSlice';
import styles from './FilterBox.module.css';
import { FILTER_BOX_BUTTON_TEXT, FILTER_BOX_POPOVER_ID } from '../../utils/constants';
const FilterBox = ({
  prefilters
}) => {
  const filterButtonRef = useRef();
  const dispatch = useDispatch();
  const {
    filtersOpened,
    filters
  } = useSelector(state => state.widenSearch);
  const handleApplyFilter = filterValues => {
    dispatch(addFilter(filterValues));
    dispatch(toggleFiltersOpened());
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    startIcon: /*#__PURE__*/React.createElement(Filter, null),
    ref: filterButtonRef,
    onClick: () => dispatch(toggleFiltersOpened()),
    className: `${styles['filter-button']} ${filtersOpened ? styles['filter-button-active'] : ''}`
  }, FILTER_BOX_BUTTON_TEXT), filtersOpened && /*#__PURE__*/React.createElement(Popover, {
    id: FILTER_BOX_POPOVER_ID,
    source: filterButtonRef,
    spacing: 0
  }, /*#__PURE__*/React.createElement(FilterBody, {
    filters: filters,
    prefilters: prefilters,
    onApplyFilter: handleApplyFilter
  })));
};
export default FilterBox;